<template>
  <div class="noData">
    <div class="svg-container">
      <BasicText
        class="overlay-text"
        color="white"
        weight="light"
      >
        <slot name="content"></slot>
      </BasicText>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">

  .dark .noData {
    background-color: unset;
  }

  .noData {
    background-color: #f0f3f5;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;

    .svg-container {
      position: relative;
      width: 400px;
      height: 130px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      background-color: @secondary-800;
    }

    .svg {
      transform: scale(1.1);
    }

    .overlay-text {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80%;
      transform: translate(-50%, -50%);
      text-align: center;
      pointer-events: none;
    }
  }
</style>
